module.exports = __webpack_public_path__ + "img/drug-9.66e8cd66.png";